module.exports = __webpack_public_path__ + "fonts/RobotoFlex-VariableFont.f15bf19.ttf";